import axios from "axios";
import { IP } from "../index";
// 查询所有订单
export async function selectallorder(data) {
  var resp = await axios.post(`${IP}/order/selectAll`, { ...data });
  return resp.data;
}

// 查询所有订单
export async function updateOrder(data) {
  var resp = await axios.post(`${IP}/order/updateOrder`, {
    ...data,
  });
  return resp.data;
}

// 删除订单
export async function deleteOrder(id) {
  var resp = await axios.post(`${IP}/order/delete`, {
    id,
  });
  return resp.data;
}

// 发货 发货订单id/物流单号
export async function updateSendState(id, logisticsNumber) {
  var resp = await axios.post(`${IP}/order/updateSendState`, {
    id,
    logisticsNumber,
    // status: 1, //已发货
  });
  return resp.data;
}

// 根据订单号查询订单详情
export async function selectOrderDetail(orderNumber) {
  var resp = await axios.post(`${IP}/order/selectOrderDetail`, {
    orderNumber,
  });
  return resp;
}
